import auth from "@/router/middlewares/auth";
import Dashboard from "@/views/General/Dashboard";

export default [
  {
    path: '/dashboard',
    name: 'general-dashboard',
    component: Dashboard,
    meta: {
      middleware: auth,
      key:'dashboard',
      'package':'general'
    }
  },
  //PAGE REDIRECT IF NOT FOUND
  {
    path: '*' || '/*' ,
    name: 'general-dashboard',
    component: Dashboard,
    meta: {
      middleware: auth,
      key:'dashboard',
      'package':'general'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/general/dashboard.js